/** @jsx jsx */
import { Fragment } from "react"
import { jsx } from "theme-ui"

import { vwoService } from "@trueskin-web/services"

import emptyCircleSvg from "./emptyCircleIcon.svg"

export const emptyCircleIcon = vwoService.isThemeRebrandedEnabled()
  ? emptyCircleSvg
  : {
      path: (
        <Fragment>
          <rect
            x="0.5"
            y="0.5"
            width="15"
            height="15"
            rx="7.5"
            fill="none"
            stroke="currentColor"
          />
        </Fragment>
      ),
      viewBox: "0 0 16 16",
    }
